import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    bookingConditionsPageId: 74,
    bookingConditionsModules: null,
  },
  getters: {
    getBookingConditionsHtml: (state) => {
      if (state.bookingConditionsModules) {
        // concatenate all the html values for each cms module on the page.
        return state.bookingConditionsModules.modules.map((m) => m.moduleSettings[0].value).join('');
      }
    },
  },
  mutations: {
    setBookingConditionsModules(state, data) {
      state.bookingConditionsModules = data;
    },
  },
  actions: {
    fetchBookingConditions({
      commit, state, dispatch, getters, rootGetters,
    }) {
      // fetch the cms modules for the booking conditions page by id.
      const path = rootGetters['applinks/getLink']('page', state.bookingConditionsPageId).url;
      axios.get(`/cms/pages/modules/bypath?path=${path}`)
        .then((res) => {
          commit('setBookingConditionsModules', res.data);
        });
    },
  },
};
